import React, { Dispatch, MouseEvent } from 'react';
import { IconButton, makeStyles, Typography } from '@material-ui/core';
import { Category } from 'types/category';
import { useTable } from 'components/table/hook/useTable';
import { BoardOrderProduct } from 'types/boardOrderProduct';
import { MoreHoriz } from '@material-ui/icons';
import { useBoardControl } from '../../hooks/useBoardControl';

const styles = makeStyles({
  p: { backgroundColor: '#17a2b8', color: '#fff' },
  o: { backgroundColor: '#ffc107' },
  a: { backgroundColor: '#8BC34A', color: '#fff' },
  d: { backgroundColor: '#007bff', color: '#fff' },
  c: { backgroundColor: '#6c757d', color: '#fff' },
  x: { backgroundColor: '#dc3545', color: '#fff' },
  status: {
    padding: '4px 10px',
    borderRadius: 0,
    fontSize: 12,
    width: 145,
  },
  iconButton: {
    justifySelf: 'baseline',
    padding: 5,
  },
});

type BoardProductItemProps = {
  product: BoardOrderProduct;
  setAnchorEl: Dispatch<HTMLButtonElement | null>;
};

const BoardProductItem: React.FC<BoardProductItemProps> = ({ product, setAnchorEl }) => {
  const classes = styles();
  const { tableTemplate } = useTable();
  const { setSelectedProduct } = useBoardControl();

  function handleClick(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();

    setSelectedProduct(product);
    setAnchorEl(e.currentTarget);
  }

  return (
    <>
      {tableTemplate
        .filter(item => !item.notShow)
        .map(item =>
          item.id === 'actions' ? (
            <IconButton className={classes.iconButton} key={item.id} onClick={handleClick}>
              <MoreHoriz />
            </IconButton>
          ) : item.id === 'formattedStatus' ? (
            <div key={item.id} className={`${classes.status} ${classes[product.status]}`}>
              <Typography variant="caption">{product[item.id]}</Typography>
            </div>
          ) : (
            <div key={item.id}>
              <Typography variant="body2">{product[item.id] as keyof Category}</Typography>
            </div>
          )
        )}
    </>
  );
};

export default BoardProductItem;
